var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 311.11 598.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.73 115.62 1.32 171.15 .06 62.29 94.73 115.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.24 .09 98.51 108.97 3.83 55.63 97.24 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.21 108.88 104.94 0 199.61 53.34 106.21 108.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.13 115.44 203.53 59.91 204.8 168.78 110.13 115.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "111.54 237.53 204.96 181.98 206.23 290.87 111.54 237.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.51 168.69 211.23 59.81 305.9 113.16 212.51 168.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.65 181.9 307.33 235.24 213.94 290.78 212.65 181.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "216.43 175.24 309.84 119.71 311.11 228.6 216.43 175.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.21 483 .96 428.92 1.39 537.8 95.21 483"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.75 360.9 .47 306.82 .9 415.72 4.76 413.5 94.75 360.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 184.74 .43 293.63 94.25 238.81 0 184.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.53 598.47 99.1 489.58 5.27 544.39 99.53 598.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.61 367.48 4.79 422.32 99.03 476.38 98.61 367.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.55 354.29 98.12 245.39 4.3 300.22 98.55 354.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.07 232.2 97.64 123.3 3.82 178.12 98.07 232.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.81 489.55 107.23 598.44 201.06 543.63 106.81 489.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "106.26 354.26 200.08 299.44 105.83 245.37 106.26 354.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.62 482.93 204.87 537 204.44 428.11 110.62 482.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "110.13 360.84 204.4 414.91 203.97 306.02 110.13 360.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.15 428.08 212.58 536.97 306.4 482.15 212.15 428.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.1 414.88 305.93 360.06 211.66 305.99 212.1 414.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "215.96 421.47 310.23 475.54 309.8 366.64 215.96 421.47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.91b0c983443100ded7ca127eb13227da.svg";
export { ForwardRef as ReactComponent };